import useCreateGetByTransferRedirectLink from "@Features/getByTransfer/hooks/useCreateGetByTransferRedirectLink";
import useGetGbtVehicleImage from "@Features/getByTransfer/hooks/useGetGbtVehicleImage";
import useCurrency from "@Currency/hooks/useCurrency";
import TransfersVehicleType
    from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersVehicle.type";
import {hasFullSnippetsData} from "@Features/getByTransfer/functions/hasFullSnippetsData";

export default function useGetGbtVehicles() {
    const {transferLink} = useCreateGetByTransferRedirectLink()
    const {getImage} = useGetGbtVehicleImage()
    const {sign} = useCurrency()

    const appendMissingProperties = (vehicles: GbtVehicleSnippetType[]) => (
        vehicles.map((vehicle) => ({
            ...vehicle,
            link: transferLink,
            priceWithCurrency: `${vehicle.price} ${sign}`,
            imageUrl: getImage(vehicle),
        }))
    )

    const getGbtVehicles = (vehicles: GbtVehicleSnippetType[] | TransfersVehicleType[]) => (
        hasFullSnippetsData(vehicles) ? vehicles : appendMissingProperties(vehicles)
    )

    return {
        getGbtVehicles,
    }
}